import {UserInfoDataSet} from "@/business/UserInfoDataSet"

export class UserStore {
  public static getMandant(store: any) : number {
    return store.getters["userstore/getMandant"]
  }
  public static getUser(store: any) : number {
    return store.getters["userstore/getUser"]
  }

  public static setUserInfo(store: any, userInfo: UserInfoDataSet ) : void {
    store.commit("userstore/setUserInfo", userInfo)
  }
}

//1073742018
export const  userstore = {
  namespaced: true,
  state : {
    userInfo: {
      userId: ""      
    }
  },

  mutations: {
    setUserInfo(state: any, payload: UserInfoDataSet) {
      state.userInfo = payload
    },
    setUser(state: any, payload: string) {
      state.userInfo.userId = payload
    }
  },

  getters: {
    getUser(state: any) : number {
      return state.userInfo.userId
    }
  }

}